import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/help-center/Navbar';
import Hero from '@/components/help-center/Hero';
import Categories from '@/components/help-center/Categories';
import PowersSection from '@/components/help-center/PowersSection';
import HomeExploreHub from '@/components/help-center/HomeExploreHub';
import PopularArticles from '@/components/help-center/PopularArticles';
import Footer from '@/components/help-center/Footer';
import { PublicPageSkeleton } from '@/components/help-center/PublicPageSkeleton';
import { useCms } from '@/components/painel/cms/cms-context';
import { getGuideCategoryHref, getGuideHref } from '@/lib/guide-routes';
import { articlesByCategory } from '@/lib/articles';

export default function HomePage() {
  const navigate = useNavigate();
  const { siteReady } = useCms();

  const handleSelectCategory = (category: string, articleId?: number) => {
    if (articleId != null) {
      const article = articlesByCategory[category]?.find((a) => a.id === articleId);
      if (article) {
        navigate(getGuideHref(category, article.slug));
        return;
      }
    }
    navigate(getGuideCategoryHref(category));
  };

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex flex-1 flex-col">
        {!siteReady ? (
          <div className="bg-[#030023]">
            <PublicPageSkeleton />
          </div>
        ) : (
          <>
            {/*
              Mobile: Novo Power → Explore → Hub → Continue explorando → Categorias → Como podemos ajudar → Footer
              Desktop: Hero → Categorias → Powers → Hub → Continue explorando → Footer
            */}
            <div className="order-5 lg:order-1">
              <Hero
                compact={false}
                mobileBanner
                onSelectCategory={handleSelectCategory}
              />
            </div>
            <div className="order-4 lg:order-2">
              <Categories onSelectCategory={handleSelectCategory} />
            </div>
            <div className="order-1 lg:order-3">
              <PowersSection />
            </div>
            <div className="order-2 lg:order-4">
              <HomeExploreHub />
            </div>
            <div className="order-3 lg:order-5">
              <PopularArticles />
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
